(() => {
  const states = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root) {
    root.querySelectorAll('[data-search-typing]').forEach(input => {
      if (states.has(input)) return;
      let terms;
      try { terms=JSON.parse(input.dataset.searchTerms || '[]'); } catch { return; }
      if (!terms.length) return;
      const base=input.dataset.searchBase || input.placeholder;
      let timer,index=0,visible=true,text=terms[0];
      const paint=()=>{input.placeholder=base+(text?' '+text:'');};
      const eligible=()=>input.isConnected&&!document.hidden&&visible&&!input.value&&document.activeElement!==input;
      function stop() {
        clearTimeout(timer);
        input.placeholder=base;
      }
      function erase() {
        if(!eligible()){stop();return;}
        if(motion.matches)return;
        const letters=Array.from(text);
        if(letters.length){
          letters.pop();
          text=letters.join('');
          paint();
          timer=setTimeout(erase,42);
        }else{
          index=(index+1)%terms.length;
          timer=setTimeout(()=>type(0),260);
        }
      }
      function type(length) {
        if(!eligible()){stop();return;}
        if(motion.matches)return;
        const letters=Array.from(terms[index]);
        text=letters.slice(0,length+1).join('');
        paint();
        timer=length+1<letters.length
          ?setTimeout(()=>type(length+1),85)
          :setTimeout(erase,2400);
      }
      function start() {
        stop();
        if(!eligible())return;
        index=0;
        text=terms[0];
        paint();
        if(!motion.matches&&terms.length>1)timer=setTimeout(erase,2400);
      }
      input.addEventListener('focus',stop);
      input.addEventListener('input',stop);
      input.addEventListener('blur',start);
      const observer=new IntersectionObserver(entries=>{
        visible=entries[0].isIntersecting;
        if(visible)start();else stop();
      });
      observer.observe(input);
      states.set(input,{start,stop,observer});
      start();
    });
  }
  function refresh(){
    states.forEach((state,input)=>{
      if(!input.isConnected){state.stop();state.observer.disconnect();states.delete(input);}
      else state.start();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document),{once:true});else initialize(document);
  document.addEventListener('visibilitychange',refresh);
  motion.addEventListener('change',refresh);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',refresh);
})();
